import { ANIMATION } from '@/config/balance.config';

/**
 * Wibracja telefonu (Vibration API).
 *
 * REALITY CHECK (Chrome 86+):
 * `navigator.vibrate()` wymaga **transient activation** — czyli user gesture
 * w obrębie ~5s lub w bezpośredniej chain'ce wywołań od user event handler'a.
 * W tej grze pety auto-atakują w pętli `update()` (60 FPS), GŁĘBOKO poza
 * user-gesture chain. Każde wywołanie navigator.vibrate w tej pętli loguje
 * `[Intervention] Blocked call to navigator.vibrate`.
 *
 * Pragmatyczna decyzja:
 *  - **Desktop**: wyłączamy całkowicie (i tak Vibration API nie działa
 *    bez urządzenia haptic, plus pollutuje console).
 *  - **Mobile (touchscreen)**: zostawiamy próby. Mobile Chrome jest bardziej
 *    liberalny dla touch events; jeśli wibracje są w trakcie active touch
 *    (np. coin pickup gdy gracz dotyka joysticka), zadziałają.
 *  - **Brak transient activation**: i tak Chrome zablokuje, ale bez intervention
 *    spam (no-op'ujemy przed wywołaniem).
 *
 * Wykrywanie urządzenia: `navigator.maxTouchPoints > 0` — true gdy device ma
 * ekran dotykowy (mobile/tablet, w tym 2-in-1 z touch). Desktop bez touch'a → 0.
 */

const IS_TOUCH_DEVICE =
  typeof navigator !== 'undefined' &&
  typeof navigator.maxTouchPoints === 'number' &&
  navigator.maxTouchPoints > 0;

const HAS_VIBRATE_API =
  typeof navigator !== 'undefined' && 'vibrate' in navigator;

/** Mistrzowski przełącznik — true tylko gdy ma sens próbować. */
const ENABLED = IS_TOUCH_DEVICE && HAS_VIBRATE_API;

function vibrate(pattern: number | number[]): void {
  if (!ENABLED) return;
  try {
    navigator.vibrate(pattern);
  } catch {
    // Chrome może rzucić jeśli karta niewidoczna / brak transient activation.
    // Ignorujemy — wibracje to nice-to-have, nie gameplay-critical.
  }
}

export const Haptics = {
  /** Krótkie potwierdzenie ukończonego przytrzymania obiektu świata. */
  worldInteractionConfirmed(): void {
    vibrate(ANIMATION.haptics.worldInteractionConfirmedMs);
  },
  petAttack(): void {
    vibrate(ANIMATION.haptics.petAttackMs);
  },
  coinPickup(): void {
    vibrate(ANIMATION.haptics.coinPickupMs);
  },
  destructibleDestroyed(): void {
    vibrate(ANIMATION.haptics.destructibleDestroyedMs);
  },
};
